if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }
      showMeterErrorPopup(message) {
          alert(message);
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        let productWrapper = this.submitButton.closest('.product-main-info-wrapper');


        let coutureWrapper = productWrapper.querySelector('.couture-check');

        let coutureProduct = coutureWrapper.dataset.coutureProduct === 'true';
        let coutureCart    = coutureWrapper.dataset.coutureCart === 'true';
        let emptyCart    = coutureWrapper.dataset.cart === 'true';
        if(!emptyCart){
          if (coutureProduct && !coutureCart){
              this.newErrorMessage(Messages.coutureError);
              return;
          }else if(!coutureProduct && coutureCart){
              this.newErrorMessage(Messages.normalError);
              return;         
          }
        }


        let config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        let formData = new FormData(this.form);

        if(productWrapper.classList.contains('old-meter')){
        let inputElement = productWrapper.querySelector('meter-quantity .meter-input');
        let inputQty = inputElement ? inputElement.value : 2.5;
        let inputQtyNum = parseFloat(inputQty) * 2;
          console.log(inputQtyNum, 'input old meter');
          formData.set('quantity', inputQtyNum);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const variantId = formData.get('id'); 
        const beingAddedQty = parseInt(formData.get('quantity') || 1);

        const qtyInput = document.querySelector('.price-per-item__container .quantity__input');

        let maxLimit = qtyInput && qtyInput.max ? parseInt(qtyInput.max) : null;
        let cartQty = qtyInput && qtyInput.dataset.cartQuantity ? parseInt(qtyInput.dataset.cartQuantity) : null;

            if (maxLimit !== null && !isNaN(maxLimit)) {

              const alreadyInCartQty = cartQty !== null ? cartQty : 0;
              const finalQty = alreadyInCartQty + beingAddedQty;

              if (finalQty > maxLimit) {
                let errorMessage = `Maximum ${maxLimit} items can only be added in a cart.`;
                this.newErrorMessage(errorMessage);

                return;
              }
            }else if(productWrapper.classList.contains('new-meter')){
              

              const items = [];
              let errorData = null;

              const checkAllBox = productWrapper.querySelector(
                '.buy-complete-check .variant-checkbox'
              );

              document.querySelectorAll('.meter-row').forEach(row => {
                const checkbox = row.querySelector('.variant-checkbox');
                const input = row.querySelector('.meter-input');

                if (!checkbox || !input) return;

                // Skip unchecked rows when NOT "check all"
                if (!checkAllBox.checked && !checkbox.checked) return;

                const variantId = parseInt(checkbox.value, 10);

                const baseQty = checkAllBox.checked
                  ? parseFloat(input.getAttribute('min')) || 0
                  : parseFloat(input.value) || 0;

                const beingAddedQty = baseQty * 2;

                const alreadyInCart = parseFloat(input.getAttribute('data-cart')) || 0;
                const maxLimit = parseFloat(input.getAttribute('data-max')) || 0;
                const variantTitle = checkbox.getAttribute('data-title');

                if (maxLimit > 0 && (beingAddedQty + alreadyInCart) > maxLimit) {
                  if (!errorData) {
                    errorData = {
                      title: variantTitle,
                      limit: maxLimit / 2
                    };
                  }
                  return;
                }

                items.push({
                  id: variantId,
                  quantity: beingAddedQty
                });
              });

  
              if (errorData) {
                  let errorMessage = `${errorData.title} has a maximum limit of ${errorData.limit} meters per cart.`;
                  this.newErrorMessage(errorMessage);
  
                  return;
              }
  
              const payload = {
                  items: items
              };
  
              if (this.cart) {
                  payload.sections = this.cart.getSectionsToRender().map(s => s.id);
                  payload.sections_url = window.location.pathname;
                  this.cart.setActiveElement(document.activeElement);
              }
  
              // Final config for POST request
              config = {
                  method: 'POST',
                  headers: {
                      'Content-Type': 'application/json',
                      'Accept': 'application/json',
                  },
                  body: JSON.stringify(payload)
              };
            }



            return fetch(`${routes.cart_add_url}`, config)
              .then((response) => response.json())
              .then((response) => {

                if (response.status) {
                  publish(PUB_SUB_EVENTS.cartError, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    errors: response.errors || response.description,
                    message: response.message,
                  });
                  // this.handleErrorMessage(response.description);
                  this.newErrorMessage(response.description);

                  const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
                  if (!soldOutMessage) return;
                  this.submitButton.setAttribute('aria-disabled', true);
                  this.submitButtonText.classList.add('hidden');
                  soldOutMessage.classList.remove('hidden');
                  this.error = true;
                  return;
                } else if (!this.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }

                const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
                if (!this.error)
                  publish(PUB_SUB_EVENTS.cartUpdate, {
                    source: 'product-form',
                    productVariantId: formData.get('id'),
                    cartData: response,
                  }).then(() => {
                    CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                  });
                this.error = false;

                const quickAddModal = this.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        CartPerformance.measure("add:paint-updated-sections", () => {
                          this.cart.renderContents(response);
                        });
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  CartPerformance.measure("add:paint-updated-sections", () => {
                    this.cart.renderContents(response);
                  });
                }
              })
              .catch((e) => {
                console.error(e);
              })
              .finally(() => {
                this.submitButton.classList.remove('loading');
                if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                this.querySelector('.loading__spinner').classList.add('hidden');
                
                CartPerformance.measureFromEvent("add:user-action", evt);
                const bottomCountBubble = document.querySelector("#bottom-count-bubble");
                if (bottomCountBubble.classList.contains("hidden")) {
                  bottomCountBubble.classList.remove("hidden");
                }
                refreshMeterProductWrapper();
              });


      }
      newErrorMessage(errorMessage) {

          const errorPopup = document.querySelector('.main-error-popup');
          const msg = errorPopup.querySelector('.main-error-popup p');

          msg.textContent = errorMessage;
          errorPopup.setAttribute('open', true);

          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading__spinner').classList.add('hidden');
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        let preOrder = this.submitButton.getAttribute('data-preorder');
        console.log("preOrder", preOrder);
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          if(preOrder){
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.preOrder;
          }else{
            this.submitButton.removeAttribute('disabled');
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
